<div class="environment-switch pb-3-sa pt-3-sa p-3">
    <i class="btn-close icon-edponline-Bop-071" (click)="closeModal()"></i>
    <div class="d-flex flex-column justify-content-between h-100">
        <h3>Ambientes</h3>
        <button type="button" (click)="switch(environment)"
                class="btn btn-primary submit-button text-uppercase"
                *ngFor="let environment of environments">
            {{ environment }}
        </button>
    </div>
</div>
